import LineLogin from './LineLogin'
import LineProfile from './LineProfile'
import LineInThailand from './LineInThailand'
import LinePrice from './LinePrice'
import LineRegister from './LineRegister'

export default {
  LineLogin,
  LineProfile,
  LineInThailand,
  LinePrice,
  LineRegister
}



// WEBPACK FOOTER //
// ./src/components/LineOA/index.js